import React, { useState } from "react";
import "./Navbar.css";
import {Link} from 'react-router-dom'

const Mobile = () => {
    const [isOpen, setIsOpen] = useState(false);
  const [openMenus, setOpenMenus] = useState({}); // track multiple open submenus

  const toggleMenu = () => setIsOpen(!isOpen);

  const toggleSubMenu = (id) => {
    setOpenMenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div>
      <button className="menu-button" onClick={toggleMenu}>
        <i class="mobile-nav-toggle d-xl-none bi bi-list" aria-controls="navmenu"></i>
      </button>

      <nav className={`mobile-menu ${isOpen ? "open" : ""}`}>
        <button className="close-button" onClick={toggleMenu}>
          ✕
        </button>

        <ul>

        <li className="has-submenu" id="main-nav">
            <span>Takshila VLS</span>
            <i
              className={`bi toggle-dropdown ${
                openMenus["takshila"] ? "bi-chevron-up" : "bi-chevron-down"
              }`}
              onClick={() => toggleSubMenu("takshila")}
            ></i>
            <ul className={`sub-menu ${openMenus["takshila"] ? "open" : ""}`}>
              <li><a href='/about-us'>About Us</a></li>
                      <li><a href='/vision'>Vision</a></li>
                      <li><a href='/why-join-us'>Why Join Us</a></li>
                      <li><a href='https://www.takshila-vlsi.com/blog' target='_blank'>Blog</a></li>
                      <li><a href='/apply-trainer/'>Apply as Trainer</a></li>
            </ul>
          </li>

          <li className="has-submenu" id="main-nav">
            <span>Courses</span>
            <i
              className={`bi toggle-dropdown ${
                openMenus["course"] ? "bi-chevron-up" : "bi-chevron-down"
              }`}
              onClick={() => toggleSubMenu("course")}
            ></i>
            <ul className={`sub-menu ${openMenus["course"] ? "open" : ""}`} id="sub-nav">

              <li className="has-submenu">
                <span>For Freshers</span>
                <i
                  className={`bi toggle-dropdown ${
                    openMenus["freshers"] ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                  onClick={() => toggleSubMenu("freshers")}
                ></i>
                <ul className={`sub-menu ${openMenus["freshers"] ? "open" : ""}`} id="sub-sub-nav">
                  <li><a href='/product/physical-design'>Physical Design</a></li>
                  <li><a href="/product/asic-verification/">ASIC Verification</a></li>
                  <li><a href="/product/analog-layout-design/">Analog Layout Design</a></li>
                  <li><a href="/product/design-for-test/">Design For Test</a></li>
                  <li><a href="/product/analog-circuit-design/">Analog Circuit Design</a></li>
                  <li><a href="/product/rtl-coding-fpga-design/">RTL Coding and FPGA Design</a></li>
                  <li><a href="/product/embedded-systems-training/">Embedded Systems Training</a></li>
                </ul>
              </li>
              <li className="has-submenu">
                <span>For Working Professionals</span>
                <i
                  className={`bi toggle-dropdown ${
                    openMenus["profess"] ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                  onClick={() => toggleSubMenu("profess")}
                ></i>
                <ul className={`sub-menu${openMenus["profess"] ? "open" : ""}`} id="sub-sub-nav">
                <li><a href="/product/physical-design-part-time/">Physical Design-Part Time</a></li>
                <li><a href="/product/asic-verification-part-time/">ASIC Verification-Part Time</a></li>
                <li><a href="/product/analog-layout-design-part-time/">Analog Layout Design-Part Time</a></li>
                <li><a href="/product/design-for-test-part-time/">Design For Test-Part Time</a></li>
                <li><a href="/product/analog-circuit-design/">Analog Circuit Design</a></li>
                <li><a href="/product/rtl-coding-fpga-design-part-time/">RTL Coding and FPGA Design-Part Time</a></li>
                <li><a href="/product/finfet-layout-design/">FINFET Layout Design Training</a></li>
                <li><a href="/product/uvm-training/">UVM Training</a></li>
                <li><a href="/product/perl-scripting/">PERL Scripting</a></li>
                </ul>
              </li>
              <li className="has-submenu">
                <span>Online Courses</span>
                <i
                  className={`bi toggle-dropdown ${
                    openMenus["online"] ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                  onClick={() => toggleSubMenu("online")}
                ></i>
                <ul className={`sub-menu ${openMenus["online"] ? "open" : ""}`} id="sub-sub-nav">
                <li><a href="/product/physical-design-online/">Physical Design Online</a></li>
                <li><a href="/product/asic-verification-online/">ASIC Verification Online</a></li>
                <li><a href="/product/analog-layout-design-online/">Analog Layout Design Online</a></li>
                <li><a href="/product/design-for-test-dft-online/">Design For Test Online</a></li>
                <li><a href="/product/analog-circuit-design-online/">Analog Circuit Design Online</a></li>
                <li><a href="/product/rtl-coding-and-fpga-design-online/">RTL Coding and FPGA Design Online</a></li>
                <li><a href="/product/uvm-training-online/">UVM Training Online</a></li>
                </ul>
              </li>

              <li><a href='/course-videos/'>Online Course Videos</a></li>
              <li><a href='/events/demo-class/'>Free Demo Class</a></li>
              <li><a href='/events/1-day-free-vlsi-training/'>1-Day Free VLSI Training</a></li>
            </ul>
          </li>

          <li id="main-nav"><a href="/course-calendar">Course Calendar</a></li>
          <li id="main-nav"><a href="/corporate-trainings/">Corporate</a></li>
          <li id="main-nav"><a href="/vlsi-internship/">VLSI Internship</a></li>
          <li id="main-nav"><a href='/academic/'>Academic</a></li>
          <li id="main-nav"><a href='/placements'>Placements</a></li>
          <li id="main-nav"><a href='/contact-us/'>Contact</a></li>
          <li id="main-nav"><a href='https://www.takshila-vlsi.com/blog' target='_blank' rel="noopener noreferrer">Blog</a></li>

         

        </ul>
      </nav>

      {isOpen && <div className="overlay" onClick={toggleMenu}></div>}
    </div>
  );
};

export default Mobile;
